import {t} from "i18next";
import Selector from "../../generic/Selector";
import PartialPayment from "../PartialPayment";
import Installment from "../Installment";

const PaymentTypeSelector = ({
                                 selectedPaymentType,
                                 handlePaymentTypeSelect,
                                 hasPartialPayment,
                                 hasInstallment,
                                 installmentShow,
                                 paymentOptions,
                                 handlePaymentClick,
                                 installment,
                                 setInstallment,
                                 partialPayText
}) => {
    const paymentTypeOptions = [
        {
            id: 'partial',
            name: t('travel.partialPayment'),
            type: 'partial'
        },
        {
            id: 'installment',
            name: t('travel.installmentPayment'),
            type: 'installment'
        }
    ];

    const selectedOption = paymentTypeOptions.find(opt => opt.type === selectedPaymentType) || paymentTypeOptions[0]

    return (
        <>
            {(hasPartialPayment && hasInstallment) && (
                <div className="checkout__input-wrapper radio-input">
                    <Selector
                        options={paymentTypeOptions}
                        value={selectedOption}
                        onChange={handlePaymentTypeSelect}
                        placeholder={t('travel.selectPaymentType')}
                        label={t('travel.selectPaymentType')}
                        optionRender={(item) => item.name}
                    />
                </div>
            )}
            {selectedPaymentType === 'partial' &&
                <PartialPayment option20={paymentOptions.option20} option50={paymentOptions.option50} handlePaymentClick={handlePaymentClick} partialPayText={partialPayText}/>
            }
            {installmentShow &&
                <Installment installment={installment} setInstallment={setInstallment}/>
            }
        </>
    )
}

export default PaymentTypeSelector;